import React from 'react';
import LegacyBreadcrumbAdapter from '@jira/platform__breadcrumbs/src/legacy-breadcrumb-adapter/index.tsx';

export function BreadcrumbAdapter(): React.JSX.Element {
	return <LegacyBreadcrumbAdapter />;
}
